import { InfoCircle } from '@assets/svgs';
import { PercentField } from '@components/percentField/PercentField';
import { round } from '@utils/number';
import { CollapsedField } from '@components/quoteDetails/CollapsedField';
import { QFCTypeExecuted } from '@components/quoteDetails/QuoteFieldControl';
import { AdditionalInfoLinkProps } from '@components/container/AdditionalInfoLink';
import { Box } from '@mui/system';
import { FontSize } from '@store/types/UserStoreSlice.type';
import { adjustLineHeight } from '@theme/styleOverrides/typography';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';

export interface QuotePercentFieldProps extends QFCTypeExecuted {
  onBlur: () => void;
  isRequired: boolean;
  isRequiredBeforeBind?: boolean;
  additionalInfoLink?: AdditionalInfoLinkProps;
}

export const QuotePercentField = ({
  setValue,
  attributeType,
  errorMessage,
  value,
  isCollapsed,
  hoverText,
  externalIcon,
  isRequired,
  isRequiredBeforeBind,
  isReadOnly,
  onBlur,
  additionalInfoLink,
}: QuotePercentFieldProps) => {
  const layoutPreferences = useStore((state) => state.layoutPreferences, shallow);

  if (isCollapsed) {
    return (
      <CollapsedField
        label={attributeType.label}
        value={value?.toString() ? `${round(Number(value) * 100, 8)}%` : undefined}
        deprecated={attributeType.deprecated}
      />
    );
  }
  return (
    <Box
      sx={{
        '& .MuiFormHelperText-root': {
          lineHeight: `${adjustLineHeight(24, layoutPreferences.fontSize ?? FontSize.DEFAULT)}px`,
          margin: 0,
        },
      }}
    >
      <PercentField
        error={!!errorMessage}
        helperText={errorMessage ?? attributeType.helpText ?? ' '}
        onBlur={onBlur}
        inputLabel={attributeType.label}
        inputLabelIcon={hoverText ? <InfoCircle style={{ flexShrink: 0 }} /> : null}
        tooltipTitle={hoverText}
        externalIcon={externalIcon}
        style={{ width: '100%' }}
        value={value as number | undefined}
        onChangeInput={(v) => {
          setValue(v === undefined ? null : v);
        }}
        required={isRequired}
        requiredBeforeBind={isRequiredBeforeBind}
        disabled={isReadOnly}
        additionalInfoLink={additionalInfoLink}
        deprecated={attributeType.deprecated}
      />
    </Box>
  );
};
